import {
  AppBar,
  Button,
  IconButton,
  Stack,
  Toolbar,
  Tooltip,
  Typography,
  useMediaQuery,
  useTheme,
} from '@mui/material';
import { usePermissions } from '@userProfile/hooks';
import { viewer3dSelectors } from '@viewer3D/redux';
import { useSelector } from 'react-redux';
import { FolderOpenOutline } from '@deepup/icons';
import { getOneDriveLink } from '@projects/utils/onedrive';
import { userProfileSelectors } from '@userProfile/redux';
import { UserRole } from '@userProfile/redux/types';
import { AddressSearchField } from './AddressSearchField';
import { DownloadButton } from './DownloadButton';
import { UploadButton } from './ExternalData/UploadButton';
import { ScanStats } from './ScanStats';
import { MetadataInfoBox } from './ProjectMetadata/MetadataInfoBox';

export const ProjectBar = () => {
  const permissions = usePermissions();
  const project = useSelector(viewer3dSelectors.selectedProject)!;

  const role = useSelector(userProfileSelectors.selectUserRole);
  const isAdmin = role === UserRole.Admin;

  const theme = useTheme();
  const isSmallScreen = useMediaQuery(theme.breakpoints.down('xl'));

  return (
    <AppBar position="relative" elevation={2}>
      <Toolbar>
        <Stack
          direction="row"
          justifyContent="space-between"
          width="100%"
          alignItems="center"
          gap={2}
        >
          <Stack width="100%" maxWidth="100%" overflow="hidden">
            <Tooltip title={project.name}>
              <Typography variant="h6" noWrap>
                {project.name}
              </Typography>
            </Tooltip>
            <ScanStats />
          </Stack>
          <Stack direction="row" gap={1} alignItems="center" flexShrink={0}>
            {isAdmin && <MetadataInfoBox />}
            {!isSmallScreen && (
              <Button
                href={getOneDriveLink(project)}
                target="_blank"
                variant="outlined"
                color="secondary"
                sx={{ width: 'max-content' }}
                startIcon={<FolderOpenOutline fill="white" />}
              >
                Design Data
              </Button>
            )}
            {isSmallScreen && (
              <IconButton href={getOneDriveLink(project)} target="_blank">
                <FolderOpenOutline fill="white" />
              </IconButton>
            )}
            <UploadButton />
            {permissions.canDownloadProjects && <DownloadButton />}
            <AddressSearchField />
          </Stack>
        </Stack>
      </Toolbar>
    </AppBar>
  );
};
